import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { resolveImage } from "@/lib/api";
import { initials as initialsFn } from "@/lib/format";
import { ShieldCheck, Package, Heart, Pencil, LifeBuoy, Bell, FileText, Trash2, LogOut, ChevronRight, Shield } from "lucide-react";

const items = [
  { to: "/my-listings", label: "My Listings", icon: Package },
  { to: "/favorites", label: "Saved items", icon: Heart },
  { to: "/edit-profile", label: "Edit profile", icon: Pencil },
  { to: "/support", label: "Support", icon: LifeBuoy },
  { to: "/notification-settings", label: "Notification settings", icon: Bell },
  { to: "/privacy", label: "Privacy policy", icon: FileText },
  { to: "/delete-account", label: "Delete account", icon: Trash2, danger: true },
];

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6">
      <div className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5">
        <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-brand text-lg font-bold text-white">
          {user.avatar_url ? <img src={resolveImage(user.avatar_url)} alt="" className="h-full w-full object-cover" /> : initialsFn(user.name)}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5"><h1 className="truncate font-display text-xl font-extrabold">{user.name}</h1>{user.verified && <ShieldCheck className="h-5 w-5 text-sky-600" />}</div>
          <p className="truncate text-sm text-muted-foreground">{user.email}</p>
          <p className="text-sm text-muted-foreground">{user.phone}</p>
        </div>
      </div>

      {user.is_admin && (
        <button onClick={() => navigate("/admin")} data-testid="profile-admin-btn" className="mt-4 flex w-full items-center gap-3 rounded-2xl border border-brand bg-brand p-4 text-left text-white">
          <Shield className="h-5 w-5" />
          <span className="flex-1 font-semibold">Admin panel</span>
          <ChevronRight className="h-4 w-4" />
        </button>
      )}

      <div className="mt-4 divide-y divide-border overflow-hidden rounded-2xl border border-border bg-card">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <button key={it.to} data-testid={`profile-link-${it.label.toLowerCase().replace(/ /g, "-")}`} onClick={() => navigate(it.to)} className="flex w-full items-center gap-3 p-4 text-left transition hover:bg-secondary">
              <Icon className={`h-5 w-5 ${it.danger ? "text-destructive" : "text-muted-foreground"}`} />
              <span className={`flex-1 font-medium ${it.danger ? "text-destructive" : ""}`}>{it.label}</span>
              <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>
          );
        })}
        <button onClick={() => { logout(); navigate("/login"); }} data-testid="profile-logout" className="flex w-full items-center gap-3 p-4 text-left text-destructive transition hover:bg-secondary">
          <LogOut className="h-5 w-5" />
          <span className="flex-1 font-medium">Log out</span>
        </button>
      </div>
    </div>
  );
}
